export default class EmploymentAllowanceHasNoEffectText {
  constructor(leaveType) {
    this.leaveType = leaveType
  }

  getText() {
    return `Allowance is not affected, because **${this.leaveType.name}** is set up to not deduct from any allowance`
  }
}
